import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MarkdownBlock } from '../../models/markdown-block';
import { ContentBlockLayout, IContentBlockControl } from '../../models/content-block-control';

@Component({
  selector: 'app-markdown-block',
  templateUrl: './markdown-block.component.html',
  styleUrls: ['./markdown-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class MarkdownBlockComponent implements OnInit, IContentBlockControl {
  @Input()
  markdownBlock: MarkdownBlock;

  @Input()
  layout = ContentBlockLayout.Normal;

  constructor() {}

  ngOnInit() {}
}
